export const MAX_TABLET_WIDTH = 1024;
export const MAX_MOBILE_WIDTH = 767;

export const DEFAULT_TIMEOUT_TIME = 300;

export const KEY_ESCAPE = 'Escape';

export const VALIDATE_ERROR = 2;
export const ERROR_STATUS = 422;

export const PAUSED_VIDEO = 'pauseVideo';

export const STOP_VIDEO = 'stopVideo';

export const PLAY_VIDEO = 'playVideo';

export const MOBILE_DEVICE_REGEXP = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
